import React, { useState, useEffect } from "react";
import "./signin.scss";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import KeyIcon from "@mui/icons-material/Key";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

const Signin = () => {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isEmailSubmitted, setIsEmailSubmitted] = useState(false);
  const [showForgetPasswordButton, setShowForgetPasswordButton] =
    useState(false);
  const [loginError, setLoginError] = useState("");
  const { state } = useLocation();
  const emailSubmitted = state?.isEmailSubmitted || false;
  const prevEmail = state?.email || '';
  const [email, setEmail] = useState(prevEmail || '');


  const handleSignIn = async (event) => {
    try {
      event.preventDefault();
      if (!password) {
        setLoginError("*Please enter your password");
        return;
      }

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/users/login`,
        {
          email: email,
          password: password,
          fromAdminPortal: true,
        }
      );
      if (response.data.message === "Logged In Successfully") {
        localStorage.setItem("authToken", response.data.token);
        const userData = JSON.stringify(response.data.user);
        localStorage.setItem("userInfo", userData);
        window.location.href = "/app-users";
      } else {
        console.log("Login failed!");
      }
    } catch (error) {
      console.error("Error occurred during login:", error);

      if (error.response?.data?.error) {
        setLoginError("*Please check your email and password");
      } else {
        setLoginError("An error occurred. Please try again later.");
      }
    }
  };

  const handleContinueClick = async () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@.]+\w+$/;
    if (!email) {
      setLoginError("*Please enter your email address");
    } else if (!emailRegex.test(email)) {
      setLoginError("*Please check your email address");
    } else {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/users/email`,
          {
            email: email,
          }
        );
  
        if (response.data.exists === true) {
          setLoginError("");
          setIsEmailSubmitted(true);
          setShowForgetPasswordButton(true);
        } else {
          setLoginError("*Please check your email address");
        }
      } catch (error) {
        console.error("Error occurred while checking email:", error);
      }
    }
  };
  
  

  console.log("error: email", loginError, email);
  const togglePasswordVisibility = (e) => {
    if (e.type === 'click' || e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      setShowPassword(!showPassword);
    }
  };

  const handleInputChange = (event) => {
    setEmail(event.target.value);
    if (loginError) setLoginError('');
  };

  const handleInputPassword = (event) => {
    setPassword(event.target.value);
    if (loginError) setLoginError('');
  };

  const handleKeyDown = (e, action) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      action(e);
    }
  };

  const handleForgetButton = () => {
    navigate("/password-reset", {
      state: {
        email: email,
        isEmailSubmitted: isEmailSubmitted,
      },
    });
  };

  useEffect(() => {
    document.title = "Sign In - Cash Wrap";
  }, []);

  const emailBoxClick = () => {
    setIsEmailSubmitted(false);
    setShowForgetPasswordButton(false);
    navigate("/sign-in", {
      state: {
        useremail: email,
      },
    });
  };

  return (
    <div className="wrapper-all">
      <div className="first-half">
        <div className="logo">
          <div className="avatar-container">
            <span className="custom-avatar">M</span>
          </div>
        </div>
        <div className="title-body-wrapper">
          <div className="title">
            <p style={{ marginBottom: "4px" }}>Sign In</p>
          </div>

          <div className="title-body">
            {isEmailSubmitted || emailSubmitted ? (
              <div className="dropdown-show">
                <button
                  type="button"
                  className="custom-dropdown-button"
                  id="dropdownMenuLink"
                  onClick={emailBoxClick}
                  onKeyDown={(e) => handleKeyDown(e, emailBoxClick)}
                  aria-label="Change email"
                  aria-haspopup="true"
                  aria-expanded="false"
                  tabIndex="0"
                >
                  {email || prevEmail}
                  <ArrowDropDownIcon className="arrow-icon" />
                </button>
              </div>
            ) : (
              <p>to your Cash Wrap account</p>
            )}
          </div>
        </div>
      </div>

      {!isEmailSubmitted && !emailSubmitted ? (
        <div className="field">
          <MailOutlineIcon />
          <input
            type="email"
            name="email"
            value={email}
            id="userName"
            placeholder="Email"
            onChange={handleInputChange}
            onKeyDown={(e) => e.key === 'Enter' && handleContinueClick()}
            aria-label="Email address"
            autoComplete="username"
          />
        </div>
      ) : null}

      {isEmailSubmitted || emailSubmitted ? (
        <div className="field">
          <KeyIcon className="key-icon" />
          <input
            type={showPassword ? "text" : "password"}
            name="password"
            id="password"
            placeholder="Password"
            onChange={handleInputPassword}
            onKeyDown={(e) => e.key === 'Enter' && handleSignIn(e)}
            aria-label="Password"
            autoComplete="current-password"
          />
          <button
            type="button"
            className="material-icon"
            onClick={togglePasswordVisibility}
            onKeyDown={togglePasswordVisibility}
            aria-label={showPassword ? 'Hide password' : 'Show password'}
            tabIndex="0"
          >
            {showPassword ? (
              <VisibilityIcon className="visibility-icon" />
            ) : (
              <VisibilityOffIcon className="visibility-off-icon" />
            )}
          </button>
        </div>
      ) : null}
      {loginError && <div className="error-message">{loginError}</div>}
      <div className="button-container">
        {showForgetPasswordButton || emailSubmitted ? (
          <button 
            type="button"
            className="forgot-button" 
            onClick={handleForgetButton}
            onKeyDown={(e) => handleKeyDown(e, handleForgetButton)}
            tabIndex="0"
          >
            Forgot Password
          </button>
        ) : null}
        {!isEmailSubmitted && !emailSubmitted ? (
          <button
            type="button"
            className="button-common"
            onClick={handleContinueClick}
          >
            Continue
          </button>
        ) : (
          <button
            type="button"
            className="signin-button-common"
            onClick={handleSignIn}
          >
            Sign In
          </button>
        )}
      </div>
    </div>
  );
};

export default Signin;
